/**
 * Чинні назви часових поясів IANA (PRF-04, UX-43). ICU у браузері тримається ідентифікаторів CLDR
 * (`Europe/Kiev`, `Asia/Calcutta`), а PostgreSQL (tzdata без `backward`) знає лише чинні IANA
 * (`Europe/Kyiv`, `Asia/Kolkata`) і відхиляє решту: `422 time_zone_invalid`. Тому все, що йде на
 * сервер, спершу проходить `canonicalZone` (пам'ять проєкту: timezone-names-node-vs-postgres).
 * Підписи й перелік для вибору — `zone-names.ts` (лише сторінка профілю).
 */

/** Застарілі назви CLDR/ICU → чинні IANA. Лише ті, що реально віддає `Intl.supportedValuesOf`. */
const CANONICAL: Readonly<Record<string, string>> = {
  'Europe/Kiev': 'Europe/Kyiv',
  'Europe/Uzhgorod': 'Europe/Kyiv',
  'Europe/Zaporozhye': 'Europe/Kyiv',
  'Asia/Calcutta': 'Asia/Kolkata',
  'Asia/Katmandu': 'Asia/Kathmandu',
  'Asia/Rangoon': 'Asia/Yangon',
  'Asia/Saigon': 'Asia/Ho_Chi_Minh',
  'Asia/Thimbu': 'Asia/Thimphu',
  'Asia/Macao': 'Asia/Macau',
  'Asia/Ujung_Pandang': 'Asia/Makassar',
  'Atlantic/Faeroe': 'Atlantic/Faroe',
  'America/Buenos_Aires': 'America/Argentina/Buenos_Aires',
  'America/Indianapolis': 'America/Indiana/Indianapolis',
  'America/Louisville': 'America/Kentucky/Louisville',
  'America/Godthab': 'America/Nuuk',
  'America/Coral_Harbour': 'America/Atikokan',
  'Pacific/Truk': 'Pacific/Chuuk',
  'Pacific/Ponape': 'Pacific/Pohnpei',
  'Pacific/Enderbury': 'Pacific/Kanton',
  'Africa/Asmera': 'Africa/Asmara',
};

export const canonicalZone = (zone: string): string => CANONICAL[zone] ?? zone;

/** Пояс пристрою за браузером, у чинній назві IANA; `null`, якщо браузер його не віддає. */
export function deviceZone(): string | null {
  try {
    const zone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return zone ? canonicalZone(zone) : null;
  } catch {
    return null;
  }
}
